window.addEventListener("DOMContentLoaded", function() {
  // 设置目标日期（注意：JavaScript中月份从0开始，4月对应3）
  const targetDate = new Date(document.querySelector('.countdown-md25').dataset.targetTime); // 2025-04-30

  function updateCountdown() {
      const now = new Date();
      const diff = targetDate - now;

      // console.log(`%c>> $`, 'color:yellow', targetDate, now, diff)

      if (diff <= 0) {
          document.getElementById('days').textContent = '00';
          document.getElementById('hours').textContent = '00';
          document.getElementById('minutes').textContent = '00';
          document.getElementById('seconds').textContent = '00';
          return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      document.getElementById('days').textContent = days.toString().padStart(2, '0');
      document.getElementById('hours').textContent = hours.toString().padStart(2, '0');
      document.getElementById('minutes').textContent = minutes.toString().padStart(2, '0');
      document.getElementById('seconds').textContent = seconds.toString().padStart(2, '0');
  }

  // 立即更新并每秒刷新
  updateCountdown();
  setInterval(updateCountdown, 1000);

  // 注意：实际4月只有30天，如果设置为31日会自动变成5月1日
  // 建议检查日期有效性：console.log(targetDate) 查看实际日期
})